webpackJsonp([169454865925568],{

/***/ 1066:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0000_merfolk_prospector.jpg","type":"Unit","subtype":"Merfolk","cost":1,"ATK":1,"HP":1,"rules_text_1":"⤵ → Gain ①.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Merfolk Prospector","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"Wise fish know that gold doesn't buy happiness, but it does help to have some around.","color":"Green","spec":null,"bottom":"Tech 0","rulings":[],"keywords":[],"slug":"merfolk_prospector"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"merfolk_prospector","keywords":[],"imageRegex":"/merfolk_prospector.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-merfolk-prospector-7184525fa79689c306a3.js